<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <v-row>
          <v-col cols="6">
            <h2 class="title mb-3">パスワードを変更</h2>
            <v-card max-width="700">
              <v-card-title />
              <v-card-text>
                <v-form ref="ChangePasswordForm">
                  <v-text-field
                    v-model="newPassword"
                    type="password"
                    name="newPassword"
                    label="新しいパスワード"
                    :rules="[passwordValidation]"
                  />
                  <v-text-field
                    v-model="newPasswordConfirmation"
                    type="password"
                    name="newPasswordConfirmation"
                    label="新しいパスワードの確認（再入力）"
                    :rules="[
                      confirmationPasswordValidation(
                        newPasswordConfirmation,
                        newPassword
                      ),
                    ]"
                  />
                  <v-text-field
                    v-model="currentPassword"
                    type="password"
                    name="currentPassword"
                    label="現在のパスワード"
                  />
                </v-form>
                <v-alert dense outlined type="error" class="mb-2 mx-2">
                  <ol span class="caption">
                    <li>パスワードには半角英小文字、半角英大文字、数字、一部の記号を最低一つ以上含んで下さい</li>
                    <li>使用できる記号は #?!@$%^&*- です</li>
                    <li>パスワードの長さは8文字以上128文字以下です</li>
                  </ol>
                </v-alert>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="green darken-1" text @click="updatePassword">
                  更新する
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import headUtilsMixin from '@/mixins/head_utils'
import axios from 'axios'
import { mapState } from 'vuex'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  mixins: [headUtilsMixin, formValidationUtils],
  data: function () {
    return {
      pageTitle: 'パスワード変更',
      newPassword: null,
      newPasswordConfirmation: null,
      currentPassword: null
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  },
  methods: {
    updatePassword () {
      if (!this.$refs.ChangePasswordForm.validate()) return false

      const query = {
        user: {
          password: this.newPassword,
          password_confirmation: this.newPasswordConfirmation,
          current_password: this.currentPassword
        }
      }
      axios.patch(`/api/users/${this.currentUser.id}/passwords`, query).then(
        () => {
          const payload = {
            status: 200,
            message: 'パスワードを更新しました'
          }
          this.newPassword = null
          this.newPasswordConfirmation = null
          this.currentPassword = null
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style scoped></style>
